<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar" /> 生产管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>工单列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="90px" @keyup.enter.native="search()">
          <el-row>
            <el-col :span="6" v-if="enableSubOrder">
              <el-form-item label="子加工单" prop="subtaskOrder">
                <el-input v-model="searchform.subtaskOrder" type="text" clearable placeholder="请输入子加工单" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="工厂" prop="factoryCode">
                <el-select v-model="searchform.factoryCode" type="text" clearable filterable style="width: 100%">
                  <el-option v-for="(item, index) in factorySelectList" :key="index" :label="item.factory"
                    :value="item.factory_code" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="车间" prop="workshopCode">
                <el-select v-model="searchform.workshopCode" type="text" clearable filterable style="width: 100%">
                  <el-option v-for="(item, index) in workshopSelectList" :key="index" :label="item.workshop"
                    :value="item.workshop_code" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产线" prop="worklineCode">
                <el-select v-model="searchform.worklineCode" type="text" clearable filterable style="width: 100%">
                  <el-option v-for="(item, index) in worklineSelectList" :key="index" :label="item.workline"
                    :value="item.workline_code" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="生产状态" prop="status">
                <el-select v-model="searchform.status" type="text" clearable style="width: 100%">
                  <el-option v-for="item in orderstatus" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="订单" prop="orderNo">
                <el-input v-model="searchform.orderNo" type="text" clearable placeholder="请输入订单" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="批次" prop="batchNo">
                <el-input v-model="searchform.batchNo" type="text" clearable placeholder="请输入批次" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产品编码" prop="productCode">
                <el-select style="width:100%" v-model="searchform.productCode" clearable filterable remote
                  placeholder="请输入产品名称或编码模糊匹配" :remote-method="getProductSelectList" :loading="productSelectLoading">
                  <el-option v-for="item in productSelectList" :key="item.product_code" :label="item.product"
                    :value="item.product_code" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="质检状态" prop="quality_status">
                <el-select v-model="searchform.quality_status" clearable style="width: 100%">
                  <el-option v-for="item in qualityStatusList" :key="item.value" :label="item.label"
                    :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="生产时间" prop="datelist">
                <el-date-picker v-model="searchform.datelist" style="width: 100%" type="daterange" clearable
                  value-format="yyyy-MM-dd" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="计划时间" prop="datelist2">
                <el-date-picker v-model="searchform.datelist2" style="width: 100%" type="daterange" clearable
                  value-format="yyyy-MM-dd" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="数据状态" prop="workorder_status">
                <el-select v-model="searchform.workorder_status" type="text" style="width: 100%">
                  <el-option v-for="item in workorder_status" :key="item.value" :label="item.label"
                    :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10" :offset="1">
              <el-button v-permission="['orderlist_select']" type="primary" icon="el-icon-search" @click="search">搜索
              </el-button>
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button v-permission="['orderlist_export']" :loading="downloadLoading" type="primary" icon="document"
                @click="handleDownload">导出Excel</el-button>
              <el-button v-permission="['orderlist_add']" type="primary" @click="addOrder()">新增工单</el-button>
              <el-button v-permission="['orderlist_select']" type="primary" @click="settatle()">设置表列显示</el-button>
            </el-col>
          </el-row>

        </el-form>
      </div>
      <!-- 新增修改模块       -->
      <br />
      <Order-Add ref="orderAdd" :search="search" />
      <Order-Update ref="orderUpdate" :search="search" />
      <update-Report ref="updateReport" :report="report" :search="search" />
      <TableHeader ref="TableHeader" :tablecolumn="tablecolumn" />
      <ExportList ref="myExportList" :search="search" />
      <InstorageList ref="myInstorage" :search="search" />
      <WorkorderPacklist ref="mypacklist" :search="search" />
      <migrateData ref="migrateData" :search="search" />
      <br />
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <el-divider />
          <el-table id="parent" v-loading="tableLoading" :stripe="true" element-loading-text="拼命加载中" :data="tableData"
            style="width: 100% " :header-cell-style="{ 'text-align': 'center' }"
            :cell-style="{ 'text-align': 'center' }" border
            :default-sort="{ prop: 'produce_time', order: 'descending' }" max-height="1000">
            <!-- sortable -->
            <el-table-column v-for="item in tablerow" :key="item.key" :prop="item.key" :label="item.label"
              :fixed="item.key == 'cz' ? 'right' : false" :min-width="item.width">
              <!-- <template slot-scope="props">
                <div v-if="item.key == 'reality_instorage_count'">
                  <el-link type="primary" v-permission="['orderlist_updatecount']" @click="toinstoragelist(props.row)">
                    {{ props.row.reality_instorage_count }}</el-link>
                </div>
                <div v-else>  
                  {{ props.row[item.key] }}
                </div>
              </template> -->
            </el-table-column>

            <af-table-column prop="" label="操作" fixed="right">
              <template slot-scope="props">
                <el-popover placement="right" width="auto" trigger="click">
                  <div>
                    <el-button class="bottstycz" type="primary" v-permission="['orderlist_update']"
                      v-if="props.row.order_status == 1" @click="updateOrder(props.row.orderno)">
                      修改
                    </el-button>
                    <el-button class="bottstycz" type="danger" v-permission="['orderlist_delete']"
                      @click="deletedate(props.row.id)">
                      删除
                    </el-button>
                    <el-button class="bottstycz" type="info" v-permission="['orderlist_complete']"
                      v-if="props.row.order_status == 3" @click="completeorder(props.row)">
                      结束工单
                    </el-button>
                    <el-button class="bottstycz" type="primary" v-permission="['orderlist_export']"
                      v-if="props.row.order_status >= 4" @click="toExportList(props.row)">
                      导出
                    </el-button>
                    <!-- <el-button class="bottstycz" type="primary" size="mini" v-permission="['orderlist_details']"
                      @click="orderextendlist(props.row)">
                      扩展
                    </el-button> -->
                    <el-button class="bottstycz" type="primary" size="mini" v-permission="['orderlist_Packaging']"
                      @click="workorderpacklist(props.row)">
                      包装关系
                    </el-button>
                    <el-button class="bottstycz" type="primary" size="mini" v-permission="['orderlist_check']"
                      v-if="props.row.quality_status == 0 || props.row.quality_status == 3"
                      @click="handleBatchquality(props.row)">
                      质检审核
                    </el-button>
                    <el-button class="bottstycz" type="primary" v-permission="['orderlist_Reports']"
                      @click="updateaward(props.row)">
                      质检报告
                    </el-button>
                    <el-button class="bottstycz" type="primary" v-permission="['orderlist_updatecount']"
                      @click="toinstoragelist(props.row)">
                      入库录入明细
                    </el-button>
                    <el-button class="bottstycz" type="primary" v-permission="['orderlist_updatecount']"
                      @click="handleMigrateData(props.row)">
                      迁移数据
                    </el-button>
                  </div>
                  <el-button type="primary" slot="reference">按钮组</el-button>
                </el-popover>
              </template>
            </af-table-column>
          </el-table>
          <br />
          <el-pagination background layout="total,prev, pager, next, jumper, sizes" :total="pageTotal"
            :page-sizes="[10, 20, 50, 100]" :page-size.sync="searchform.pageSize"
            :current-page.sync="searchform.pageIndex" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </el-col>
      </el-row>

      <el-dialog title="质检审核" :visible.sync="batchqualityDialogVisible" width="30%" :close-on-click-modal="false">
        <el-form ref="batchqualityForm" :model="batchqualityForm" label-width="90px" :rules="rules">
          <el-form-item label="质检状态" prop="quality_status">
            <el-select v-model="batchqualityForm.quality_status" placeholder="请选择">
              <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="batchqualityDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleBatchqualitystatus()">确 定</el-button>
        </span>
      </el-dialog>
      <br />
    </div>
  </div>
</template>
<script>
import { orderquery, batchqualitystatus, factorylist, worklinelist, workshoplist, deletework, complete, downloadbackwork } from "@/api/plant";
import { productlist } from "@/api/base";
import TableHeader from "@/components/HeaderSearch/TableHeader";
import OrderAdd from "./components/OrderAdd";
import OrderUpdate from "./components/OrderUpdate";
import UpdateReport from "./components/UpdateReport";
import InstorageList from "./components/InstorageList";
import ExportList from "./components/exportList";
import migrateData from "./components/migrateData";
import WorkorderPacklist from "./components/workorderpacklist/workorderpacklist";
import store from "@/store";
export default {
  name: "Orderlist",
  components: { OrderAdd, OrderUpdate, UpdateReport, TableHeader, InstorageList, WorkorderPacklist, ExportList, migrateData },
  data() {
    return {
      enableSubOrder: store.state.user.enable_sub_order,
      //表格数据
      tableLoading: false,
      tableData: [],
      tablerow: [],
      tablecolumn: [
        {
          label: "工厂",
          key: "factory_code",
          width: "130",
        },
        {
          label: "车间",
          key: "workshop_code",
          width: "130",
        },
        {
          label: "产线",
          key: "workline_code",
          width: "100",
        },
        // {
        //   label: "班组",
        //   key: "workgroup_code",
        //   width: "100",
        // },
        {
          label: "订单",
          key: "orderno",
          width: "150",
        },
        {
          label: "产品",
          key: "product_name",
          width: "230",
        },
        {
          label: "规格",
          key: "specs",
          width: "80",
        },
        {
          label: "计划生产数量",
          key: "product_quantity",
          width: "120",
        },
        {
          label: "人工确认数量",
          key: "reality_instorage_count",
          width: "120",
        },
        {
          label: "批次号",
          key: "batchno",
          width: "160",
        },
        {
          label: "有效期",
          key: "period_date",
          width: "160",
        },
        {
          label: "1级采集数量",
          key: "package_level1_count",
          width: "100",
        },
        {
          label: "1级生产数量",
          key: "package_level1_produce",
          width: "100",
        },
        {
          label: "1级采集率",
          key: "harvest_rate1",
          width: "100",
        },
        {
          label: "2级采集数量",
          key: "package_level2_count",
          width: "100",
        },
        {
          label: "2级生产数量",
          key: "package_level2_produce",
          width: "100",
        },
        {
          label: "2级采集率",
          key: "harvest_rate2",
          width: "100",
        },
        {
          label: "3级采集数量",
          key: "package_level3_count",
          width: "100",
        },
        {
          label: "3级生产数量",
          key: "package_level3_produce",
          width: "100",
        },
        {
          label: "3级采集率",
          key: "harvest_rate3",
          width: "100",
        },
        // {
        //   label: "4级采集数量",
        //   key: "package_level4_count",
        //   width: "100",
        // },
        // {
        //   label: "4级生产数量",
        //   key: "package_level4_produce",
        //   width: "100",
        // },
        // {
        //   label: "4级采集率",
        //   key: "harvest_rate4",
        //   width: "100",
        // },
        // {
        //   label: "5级采集数量",
        //   key: "package_level5_count",
        //   width: "100",
        // },
        // {
        //   label: "5级生产数量",
        //   key: "package_level5_produce",
        //   width: "100",
        // },
        // {
        //   label: "5级采集率",
        //   key: "harvest_rate5",
        //   width: "100",
        // },
        {
          label: "生产开始时间",
          key: "produce_time",
          width: "140",
        },
        {
          label: "工单结束时间",
          key: "complete_time",
          width: "140",
        },
        {
          label: "计划开始时间",
          key: "plan_datetime1",
          width: "140",
        },
        {
          label: "计划完成时间",
          key: "plan_datetime2",
          width: "140",
        },
        {
          label: "计划生产日期",
          key: "plan_date",
          width: "140",
        },
        {
          label: "生产状态",
          key: "statusname",
          width: "100",
        },
        {
          label: "质检状态",
          key: "quality_statusmean",
          width: "100",
        },
      ],
      orderstatus: [
        {
          value: 1,
          label: "未下载",
        },
        {
          value: 2,
          label: "已下载",
        },
        {
          value: 3,
          label: "生产中",
        },
        {
          value: 4,
          label: "已完成",
        },
        {
          value: 9,
          label: "已关闭",
        },
      ],
      workorder_status: [
        {
          value: 0,
          label: "新数据",
        },
        {
          value: 1,
          label: "历史数据",
        },
      ],
      report: {
        id: null,
        show: false,
      },
      //产品下拉选择列表
      productSelectLoading: false,
      productSelectList: [],
      // 工厂车间 产线 下拉选择列表
      factorySelectList: [],
      workshopSelectList: [],
      worklineSelectList: [],
      //分页数据
      pageTotal: 0,
      //搜索表单数据
      searchform: {
        subtaskOrder: null,
        factoryCode: null,
        workshopCode: null,
        worklineCode: null,
        status: null,
        orderNo: null,
        batchNo: null,
        productCode: null,
        quality_status: null,
        datelist: [],
        datelist2: [],
        workorder_status: 0,
        pageIndex: 1,
        pageSize: 10,
      },
      // 导出表格变量
      tableDataDownload: [],
      downloadLoading: false,
      filename: "工单列表",
      autoWidth: true,
      bookType: "xlsx",
      batchqualityDialogVisible: false,
      statusList: [
        { value: 1, label: '质检不合格' },
        { value: 2, label: '质检合格' },
        { value: 3, label: '临时放行' },
      ],
      qualityStatusList: [
        { value: 0, label: '待质检' },
        { value: 1, label: '质检不合格' },
        { value: 2, label: '质检合格' },
        { value: 3, label: '临时放行' },
      ],
      batchqualityForm: {
        quality_status: null,
        id: null,
      },
      rules: {
        quality_status: [
          { required: true, message: "请选择状态", trigger: "blur" },
        ],
      },

    };
  },
  mounted() {
    if (this.enableSubOrder) {
      this.tablecolumn.unshift(
        {
          label: "子加工单",
          key: "subtask_order",
          width: "170",
        }
      )
    }
    this.getFactorySelectList();
    this.getProductSelectList();
    this.search();
  },
  watch: {
    'searchform.factoryCode': {
      handler(newValue, oldValue) {
        this.getWorkshopSelectList();
      },
      deep: true
    },
    'searchform.workshopCode': {
      handler(newValue, oldValue) {
        this.getWorklineSelectList();
      },
      deep: true
    },
  },
  methods: {
    toExportList(row) {
      this.$refs.myExportList.row = Object.assign({}, row);
      this.$refs.myExportList.getTabledata();
    },
    toinstoragelist(row) {
      this.$refs.myInstorage.row = Object.assign({}, row);
      this.$refs.myInstorage.getTabledata();
    },
    settatle() {
      // 设置表头
      this.$refs.TableHeader.drawer = true;
    },
    getrowshow() {
      this.tablerow = this.$refs.TableHeader.tablerow;
      this.$refs.TableHeader.drawer = false;
    },
    // 获取产品下拉列表
    getProductSelectList(value) {
      if (value !== "") {
        this.productSelectLoading = true;
        setTimeout(() => {
          this.productSelectLoading = false;
          productlist({ productName: value }).then(response => {
            this.productSelectList = response.data.data || [];
            for (var item of this.productSelectList) {
              item.product = item.product_code + " - " + item.product_name;
            }
          });
        }, 200);
      } else {
        this.productSelectList = [];
      }
    },
    // 获取工厂下拉列表
    getFactorySelectList() {
      this.factorySelectList = [];
      this.workshopSelectList = [];
      this.worklineSelectList = [];
      this.searchform.factoryCode = null;
      this.searchform.workshopCode = null;
      this.searchform.worklineCode = null;
      factorylist({ pageSize: 10000 }).then((response) => {
        this.factorySelectList = response.data.data;
        for (var item of this.factorySelectList) {
          item.factory = item.factory_code + " - " + item.factory_name;
        }
      });
    },
    // 获取车间下拉列表
    getWorkshopSelectList() {
      this.workshopSelectList = [];
      this.worklineSelectList = [];
      this.searchform.workshopCode = null;
      this.searchform.worklineCode = null;
      if (!this.searchform.factoryCode) {
        return;
      }
      workshoplist({ factory_code: this.searchform.factoryCode, pageSize: 10000 }).then((response) => {
        this.workshopSelectList = response.data.data;
        for (var item of this.workshopSelectList) {
          item.workshop = item.workshop_code + " - " + item.workshop_name;
        }
      });
    },
    // 获取产线下拉列表
    getWorklineSelectList() {
      this.worklineSelectList = [];
      this.searchform.worklineCode = null;
      if (!this.searchform.workshopCode) {
        return;
      }
      worklinelist({ workshop_code: this.searchform.workshopCode, pageSize: 10000 }).then((response) => {
        this.worklineSelectList = response.data.data;
        for (var item of this.worklineSelectList) {
          item.workline = item.workline_code + " - " + item.workline_name;
        }
      });
    },
    //请求表格数据
    fetchTableData() {
      // 列表获取
      this.tableLoading = true;
      orderquery(this.tableSearchParams()).then((response) => {
        this.tableData = response.data.data;
        this.packdate(this.tableData);
        this.currentPage = response.data.pageIndex;
        this.pageTotal = response.data.total_count;
        this.tableLoading = false;
      });
    },
    packdate(data) {
      // 拼表格数据
      data.forEach(item => {
        item.harvest_rate1 = item.package_level1_produce == 0 ? '0%' : `${(item.package_level1_count / item.package_level1_produce * 100).toFixed(2)}%`;
        item.harvest_rate2 = item.package_level2_produce == 0 ? '0%' : `${(item.package_level2_count / item.package_level2_produce * 100).toFixed(2)}%`;
        item.harvest_rate3 = item.package_level3_produce == 0 ? '0%' : `${(item.package_level3_count / item.package_level3_produce * 100).toFixed(2)}%`;
        item.harvest_rate4 = item.package_level4_produce == 0 ? '0%' : `${(item.package_level4_count / item.package_level4_produce * 100).toFixed(2)}%`;
        item.harvest_rate5 = item.package_level5_produce == 0 ? '0%' : `${(item.package_level5_count / item.package_level5_produce * 100).toFixed(2)}%`;
        if (item.min_package_unit_name) {
          item.product_quantity =
            item.product_quantity + item.product_unit_cn;
        }
        // 把数据按规则拼起来 
        item.produce_time = this.$parseTime(item.produce_time);
        item.complete_time = item.complete_time.replace(/T/, " ");
        item.plan_date = item.plan_date.replace(/T/, " ");
        item.plan_datetime1 = item.plan_datetime1 == "0001-01-01T00:00:00" ? "" : item.plan_datetime1.replace(/T/, " ");
        item.plan_datetime2 = item.plan_datetime2 == "0001-01-01T00:00:00" ? "" : item.plan_datetime2.replace(/T/, " ");
        item.factory_code = (item.factory_code || "") + (item.factory_name || "");
        item.workshop_code = (item.workshop_code || "") + (item.workshop_name || "");
        item.workgroup_code = (item.workgroup_code || "") + (item.workgroup_name || "");
        item.workline_code = (item.workline_code || "") + (item.workline_name || "");
        item.product_name = (item.product_code || "") + (item.product_name || "");
        item.supplier_id = (item.supplier_id || "") + (item.supplier_name || "");
        item.period_date = item.period_date == "0001-01-01" ? "" : item.period_date;
        // 状态为已完成 才有完成时间
        if (item.order_status !== 4) {
          item.complete_time = "";
        }
        if (item.order_status < 3) {
          // 未生产  生产时间为空
          item.produce_time = "";
        }
        switch (item.quality_status) {
          case 0:
            item.quality_statusmean = "待质检";
            break;
          case 1:
            item.quality_statusmean = "检验不合格";
            break;
          case 2:
            item.quality_statusmean = "检验合格";
            break;
          case 3:
            item.quality_statusmean = "临时放行";
            break;
        }
        switch (item.order_status) {
          case 1:
            item.statusname = "未下载";
            break;
          case 2:
            item.statusname = "已下载";
            break;
          case 3:
            item.statusname = "生产中";
            break;
          case 4:
            item.statusname = "已完成";
            break;
          case 9:
            item.statusname = "已关闭";
            break;
          default:
            break;
        }
      })
    },
    tableSearchParams() {
      return {
        subtaskOrder: this.searchform.subtaskOrder,
        factoryCode: this.searchform.factoryCode,
        workshopCode: this.searchform.workshopCode,
        worklineCode: this.searchform.worklineCode,
        status: this.searchform.status,
        orderNo: this.searchform.orderNo,
        batchNo: this.searchform.batchNo,
        productCode: this.searchform.productCode,
        quality_status: this.searchform.quality_status,
        create_start_time: this.searchform.datelist == null ? null : this.searchform.datelist[0],
        create_end_time: this.searchform.datelist == null ? null : this.searchform.datelist[1],
        plan_date_start_time: this.searchform.datelist2 == null ? null : this.searchform.datelist2[0],
        plan_date_end_time: this.searchform.datelist2 == null ? null : this.searchform.datelist2[1],
        workorder_status: this.searchform.workorder_status,
        pageIndex: this.searchform.pageIndex,
        pageSize: this.searchform.pageSize,
      }
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.tableData = [];
      this.pageTotal = 0;
      this.searchform.pageIndex = 1;
      this.searchform.pageSize = 10;
      this.getFactorySelectList();
      this.getProductSelectList();
      this.search();
    },
    //搜索事件
    search() {
      this.searchform.pageIndex = 1;
      this.fetchTableData();
    },
    //分页跳转事件
    handleCurrentChange(val) {
      this.fetchTableData();
    },
    //分页每页显示条数事件
    handleSizeChange(val) {
      this.fetchTableData();
    },
    // 质检报告修改操作
    updateaward(row) {
      this.$refs.updateReport.report.id = row.id;
      this.$refs.updateReport.report.quality_field1 = row.quality_field1 ? decodeURIComponent(row.quality_field1) : '';
      this.$refs.updateReport.getData()
      // this.$refs.updateReport.report.quality_field2 = row.quality_field2 ? row.quality_field2 : '';
      // this.$refs.updateReport.report.quality_field3 = row.quality_field3 ? row.quality_field3 : '';
      this.$refs.updateReport.report.show = true;
    },
    orderextendlist(row) {
      // 扩展属性跳转
      this.$router.push({
        path: "/orderextendlist",
        query: {
          orderno: row.orderno,
          batchno: row.batchno,
          product_code: row.product_code,
          id: row.id,
        },
      });
    },
    workorderpacklist(row) {
      // 包装单位跳转
      this.$refs.mypacklist.dialogVisible = true;
      this.$refs.mypacklist.searchform = row;
      this.$refs.mypacklist.searchform.workorder_senior_id = row.id;
      this.$refs.mypacklist.getTabledata()
      // this.$router.push({
      //   path: "/workorderpacklist",
      //   query: {
      //     orderno: row.orderno,
      //     batchno: row.batchno,
      //     product_code: row.product_code,
      //     id: row.id,
      //   },
      // });
    },
    handleBatchqualitystatus() {
      this.$refs.batchqualityForm.validate((valid) => {
        // 基础表单验证
        if (valid) {
          this.$confirm("是否确定执行该操作, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              batchqualitystatus({
                quality_status: this.batchqualityForm.quality_status,
                id: this.batchqualityForm.id,
              }).then((response) => {
                if (response.status_code == 200) {
                  this.$message({
                    type: "success",
                    message: "审核成功",
                  });
                  this.search();
                  this.batchqualityDialogVisible = false
                }
              });
            })
        }
      });
    },
    handleBatchquality(row) {
      this.batchqualityForm.id = row.id
      this.batchqualityForm.quality_status = null
      this.batchqualityDialogVisible = true
    },
    // 新增工单
    addOrder() {
      this.$refs.orderUpdate.show = false;
      this.$refs.orderAdd.show = !this.$refs.orderAdd.show;
    },
    // 修改工单
    updateOrder(orderno) {
      this.$refs.orderAdd.show = false;
      if (this.$refs.orderUpdate.orderno != orderno) {
        // 关闭之前的修改弹窗
        this.$refs.orderUpdate.show = false;
      }
      this.$refs.orderUpdate.show = true;
      this.$refs.orderUpdate.orderno = orderno;
    },
    // 删除按钮事件
    deletedate(id) {
      this.$confirm("此操作将永久删除该工单信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deletework({
            id
          }).then((response) => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.search();
          });
        })
    },
    // 结束工单
    completeorder(row) {
      this.$confirm("此操作将结束该工单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          complete({
            orderno: row.orderno,
            batchno: row.batchno,
            product_code: row.product_code,
          }).then((response) => {
            this.$message({
              type: "success",
              message: "操作成功!",
            });
            this.search();
          });
        })
    },
    // 导出表格事件
    handleDownload() {
      this.downloadLoading = true;
      var params = this.tableSearchParams();
      params.pageIndex = 1;
      params.pageSize = this.pageTotal;
      orderquery(params).then((response) => {
        this.tableDataDownload = response.data.data;
        this.packdate(this.tableDataDownload);
        console.log(this.tableDataDownload);
        import("@/vendor/Export2Excel").then((excel) => {
          const tHeader = [
            "工厂",
            "车间",
            "产线",
            // "班组",
            "订单",
            "产品",
            "计划生产数量",
            "人工确认数量",
            "批次号",
            "有效期",
            "1级采集数量",
            "1级生产数量",
            "1级采集率",
            "2级采集数量",
            "2级生产数量",
            "2级采集率",
            "3级采集数量",
            "3级生产数量",
            "3级采集率",
            "4级采集数量",
            "4级生产数量",
            "4级采集率",
            "5级采集数量",
            "5级生产数量",
            "5级采集率",
            "生产开始时间",
            "工单完成时间",
            "计划开始时间",
            "计划完成时间",
            "计划生产日期",
            "生产状态",
            "质检状态",
          ];
          const filterVal = [
            "factory_code",
            "workshop_code",
            "workline_code",
            "workgroup_code",
            "orderno",
            "product_name",
            "product_quantity",
            'reality_instorage_count',
            "batchno",
            "period_date",
            "package_level1_count",
            "package_level1_produce",
            "harvest_rate1",
            "package_level2_count",
            "package_level2_produce",
            "harvest_rate2",
            "package_level3_count",
            "package_level3_produce",
            "harvest_rate3",
            "package_level4_count",
            "package_level4_produce",
            "harvest_rate4",
            "package_level5_count",
            "package_level5_produce",
            "harvest_rate5",
            "produce_time",
            "complete_time",
            "plan_datetime1",
            "plan_datetime2",
            "plan_date",
            "statusname",
            "quality_statusmean",
          ];
          const list = this.tableDataDownload;
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth,
            bookType: this.bookType,
          });
          this.downloadLoading = false;
        });
      }); // hear
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    dataURLtoBlob(dataurl) {
      var bstr = atob(dataurl);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: "pdf" });
    },
    exportdate(row) {
      downloadbackwork({
        orderno: row.orderno,
        batcno: row.batchno,
        product_code: row.product_code.split(" ")[0],
      })
        .then((response) => {
          const content = this.dataURLtoBlob(response.data);
          const blob = new Blob([content], { type: "application/zip" });
          const fileName = response.message;
          if ("download" in document.createElement("a")) {
            // IE下载
            const elink = document.createElement("a");
            elink.download = "生产工单.zip";
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            // 谷歌火狐下载
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
            if (window.navigator.msSaveBlob) {
              // ie下载
              console.log(window.navigator.msSaveBlob);
              try {
                window.navigator.msSaveBlob(blob, fileName);
              } catch (e) {
                console.log(e);
              }
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleMigrateData(data) {
      this.$refs.migrateData.getoutbilldata(data)
    }
  },
};
</script>
<style scoped>
.bottstycz {
  display: block !important;
  width: 150px;
  margin: 5px;
}
</style>
